import Validation from '../../../data/validation/validation'
import { DateValidationRule, NumberValidationRule, StringValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from '../../../utils/UIHelper'

export const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.obligation.name, (error) => errors.name = error, { min: { value: 4, error: "Too short" }, max: { value: 30, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.obligation.type, (error) => errors.type = error, { min: { value: 1, error: "Invalid" }, max: { value: 1, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.obligation.amountType, (error) => errors.amountType = error, { min: { value: 1, error: "Invalid" }, max: { value: 1, error: "Invalid" } })
    validation.addValidationRule(NumberValidationRule, instance.state.obligation.amount, (error) => errors.amount = error, { min: { value: 0, error: "Invalid" }, max: { value: 10000000, error: "Invalid" } })
    validation.addValidationRule(DateValidationRule, instance.state.obligation.dueDate, (error) => errors.dueDate = error, { allowNull: true })
    validation.addValidationRule(StringValidationRule, instance.state.obligation.status, (error) => errors.status = error, { min: { value: 1, error: "Invalid" }, max: { value: 1, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.obligation.visibility, (error) => errors.visibility = error, { min: { value: 1, error: "Invalid" }, max: { value: 1, error: "Invalid" } })

    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

export const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        loadingObligation: false,
        creatingDvn: false,
        updating: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)
    
}